const preventContentAction = (event) => event.preventDefault();

for (const eventName of ['contextmenu', 'copy', 'cut', 'dragstart']) {
  document.addEventListener(eventName, preventContentAction, { capture: true });
}

document.addEventListener('click', (event) => {
  if (event.target instanceof Element && event.target.closest('copy-to-clipboard-component')) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, { capture: true });
